
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { HistoryTypeT } from '@/core/types/changes_history.types'

// realisations
import { changes_history } from '@/core/realisations/changes_history.realisation'

// validations
import useVuelidate from '@vuelidate/core'
import { ChangesHistoryValidation } from '@/modules/ChangesHistoryModule/validations/ChangesHistoryValidation.validation'

// constants
import { HISTORY_TYPES } from '@/core/constants/changes_history.constants'

export default defineComponent({
    components: {
        'the-button': TheButton,
        'the-select': TheSelect,
        'the-input': TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const asd = []

        const state = reactive({
            clientId: null as string | null,
            typeId: null as string | null,
            actionId: null as string | null,
        })

        const data_state = reactive({
            changes_history: new DataState<HistoryTypeT>({}),
        })

        const state_form$ = useVuelidate(ChangesHistoryValidation, state)

        const resetFilters = () => {
            state.clientId = null
            state.typeId = null
            state.actionId = null
        }

        // changes_history

        const loadHistoryTypes = async () => {
            try {
                data_state.changes_history.is_loading = true

                const response = await changes_history.getHistoryTypes()
                data_state.changes_history.list = response.data

                data_state.changes_history.is_failed = false
                data_state.changes_history.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.changes_history.failure.catchError(error)

                if (!data_state.changes_history.failure.error_state.is_cancel) {
                    data_state.changes_history.is_failed = true
                }
            } finally {
                if (!data_state.changes_history.failure.error_state.is_cancel) {
                    data_state.changes_history.is_loading = false
                }
            }
        }

        //

        onBeforeMount(loadHistoryTypes)

        const onSubmit = () => {
            state_form$.value.$touch()

            if (props.loading || state_form$.value.$invalid) return

            emit('submit', { ...state })
        }

        const onReset = () => {
            if (props.loading) return

            resetFilters()
            emit('reset')
        }

        return {
            state,
            data_state,
            state_form$,
            //
            loadHistoryTypes,
            //
            onSubmit,
            onReset,
            //
            HISTORY_TYPES,
        }
    },
})
